import React, { createContext, useCallback, useContext, useMemo, useRef, useEffect } from 'react';

const SectionMenuResetContext = createContext(null);

export function SectionMenuResetProvider({ children }) {
    const handlersRef = useRef({});

    const register = useCallback((key, fn) => {
        handlersRef.current[key] = fn;
        return () => {
            if (handlersRef.current[key] === fn) {
                delete handlersRef.current[key];
            }
        };
    }, []);

    const tryReset = useCallback((key) => {
        const fn = handlersRef.current[key];
        if (!fn) {
            return false;
        }
        return Boolean(fn());
    }, []);

    const value = useMemo(() => ({ register, tryReset }), [register, tryReset]);

    return (
        <SectionMenuResetContext.Provider value={value}>
            {children}
        </SectionMenuResetContext.Provider>
    );
}

export function useSectionMenuResetContext() {
    return useContext(SectionMenuResetContext);
}

export function useSectionMenuReset(sectionKey, handler) {
    const ctx = useSectionMenuResetContext();
    const handlerRef = useRef(handler);
    handlerRef.current = handler;

    useEffect(() => {
        if (!ctx || !sectionKey) {
            return undefined;
        }
        return ctx.register(sectionKey, () => handlerRef.current?.());
    }, [ctx, sectionKey]);
}
